import { PackagePartItem } from "../../queries/useSearchPartPackagesByVehicle";
import { WheelPartItem } from "../../queries/useSearchWheelsByVehicle";
import { createQueryStringHook } from "../../stores/useQueryState";

const useVisualizerHash = createQueryStringHook("product-id", "");
export const useVizualizerColourCode = createQueryStringHook("colour-code", "");

export const useVisualizerProductId = (
  parts: (PackagePartItem | WheelPartItem)[] | null | null[]
): ReturnType<typeof useVisualizerHash> => {
  const [hash, setHash] = useVisualizerHash();
  const defaultPart = parts?.[0]?.partDetails.primaryPart;
  const defaultHash = defaultPart?.itemId;

  const resultingHash = hash || defaultHash || "";

  return [resultingHash, setHash];
};
